import { memo } from 'react';
import { useDispatch } from 'react-redux';

function ModalsLayout1() {
  const Dispatch = useDispatch();
  // const { changePassword } = useSelector((state) => state.modals);
  // Utiliza el fragmento superior para extraer los estados e informacion de tu modal especifico.

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

export default memo(ModalsLayout1);
